import { createRoot } from 'react-dom/client'
import Helper from '../helpers/helper'
import Pricing from '../components/pricing';

window.version = 1.1;

window.mountedComponents = [];

const camelize = (text) => {
  return text.replace(/_([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
};

const domReady = function () {
  I18n.locale = document.documentElement.lang;

  // Pricing
  const pricingElements = document.querySelectorAll('.react-pricing');
  pricingElements.forEach((element) => {
    if (element.dataset.reactComponentRendered) return

    let propsHelper = JSON.parse(element.dataset.props);
    let camelizedPropsHelper = {};
    Object.keys(propsHelper).forEach((key) => {
      camelizedPropsHelper[camelize(key)] = propsHelper[key];
    });

    propsHelper = camelizedPropsHelper;

    let uuid = Helper.uuid()
    const root = createRoot(element)
    root.render(React.createElement(Pricing, propsHelper))

    window.mountedComponents.push({
      uuid: uuid,
      root: root,
      element: element
    })

    element.dataset.reactComponentRendered = true
  });
};

const unmountComponents = () => {
  window.mountedComponents.forEach((component) => {
    try {
      component.root.unmount()
    } catch (error) {
      // console.log(error)
    }
  })

  window.mountedComponents = []
};

document.addEventListener('turbolinks:load', domReady);
document.addEventListener('turbolinks:before-render', unmountComponents);
document.addEventListener('DOMContentLoaded', domReady);

var primaryScript = document.querySelector('#primary-script');
primaryScript.addEventListener('load', function () {
  if (['interactive', 'complete'].includes(document.readyState)) {
    domReady();
  }
});

if (window.primaryScriptLoaded) {
  domReady();
}

// $(window).bind('beforeunload', () => {
//   unmountComponents()
// })
